import { render, staticRenderFns } from "./AdicionarPagamentoComissaoDialog.vue?vue&type=template&id=95b70c22&"
import script from "./AdicionarPagamentoComissaoDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarPagamentoComissaoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports